module.exports = __webpack_public_path__ + "img/Karlus Morales with Grey Felt Hat.372e8b11.jpg";